module.exports = __webpack_public_path__ + "img/miracle mallet.025792a1.png";